module.exports = __webpack_public_path__ + "static/media/bg_journal.380be042.jpg";